import { ErrorHandler } from '@angular/core';

export class CustomErrorHandler extends ErrorHandler {
  handleError(error: any): void {
    // Custom error handling logic here
    console.error('Custom error handling:', error);
    // You can add your own error handling logic, such as logging or displaying messages to the user.
  }
}